import { configureStore } from '@reduxjs/toolkit';
import { load, save } from 'redux-localstorage-simple';
import { createEpicMiddleware } from 'redux-observable';
import promiseMiddleware from 'redux-promise-middleware';

import rootEpic from './epic';
import rootReducer from './reducer';

const epicMiddleware = createEpicMiddleware();
const middleware = [
  promiseMiddleware,
  epicMiddleware,
  save({ states: ['issuesV2.items.grouping'] }),
].filter(mw => !!mw);
/**
 * Since we only store part of our stores in localStorage and preloadedState expects an object with the full structure
 * of our redux store, we grab our initial state, populate the data loaded from localStorage, and return.
 */
const hydrateJobsStoreFromLocalStorage = () => {
  //  Pass the root reducer a null state + a dummy action
  const initialState = rootReducer(undefined, { type: '__INIT_LOCAL_STORAGE__' });

  // @ts-expect-error It doesn't think issuesV2 ever exists.
  const { issuesV2 } = load({ states: ['issuesV2.items.grouping'] });

  // If grouping by revision is stored, we need to prepare the issuesV2 store's structure.
  // NOTE: We can't completely rewrite issuesV2.items, but we can change what it contains.
  if (issuesV2?.items?.grouping === 'issue') {
    // @ts-expect-error This is fine.
    initialState.issuesV2.items.grouping = issuesV2.items.grouping;
    // @ts-expect-error This is fine.
    initialState.issuesV2.items.issues = [];
    // @ts-expect-error This is fine.
    delete initialState.issuesV2.items.revisions;
  }

  return initialState;
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    /**
     * This middleware will call us out (in development) when we pass non-serializable
     * values in actions or in the state. A prime example of when we do
     * this is when we store the SubNav component & navProps (which often
     * contain event handlers which cannot be serialized).
     *
     * We should try to migrate away from putting non-serializable data
     * in our stores and actions, and then enable these checks.
     *
     * Read more about it:
     * https://redux-toolkit.js.org/api/serializabilityMiddleware
     */
    serializableCheck: {
      ignoredPaths: [
        /.*navigation.navProps*./,
        /.*navigation.subnav*./,
      ],
      //  ignoreActions is turned on because the promises we use as `payload` are not serializable.
      //  We should turn this on if we ever migrate fully to RTK-Query and away from promise-middleware (which they don't want us to use).
      ignoreActions: true,
    },
  }).concat(middleware),
  preloadedState: hydrateJobsStoreFromLocalStorage(),
});

epicMiddleware.run(rootEpic);
